module.exports = __webpack_public_path__ + "static/media/network_next_grey.f5d34334.svg";